var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGlobal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.174,
    height: 103.845,
    viewBox: "0 0 102.174 103.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.979,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-global",
    transform: "translate(0.007 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3550",
    "data-name": "Grupo 3550",
    transform: "translate(10.392 75.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_822",
    "data-name": "Caminho 822",
    d: "M184.553,345.445a1.748,1.748,0,0,0-1.693,1.772,1.783,1.783,0,1,0,3.563-.064,1.74,1.74,0,0,0-1.867-1.708Z",
    transform: "translate(-143.963 -329.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_823",
    "data-name": "Caminho 823",
    d: "M333.626,345.443a1.74,1.74,0,0,0-1.836,1.736,1.776,1.776,0,1,0,3.551.009,1.733,1.733,0,0,0-1.714-1.748Z",
    transform: "translate(-253.955 -329.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_824",
    "data-name": "Caminho 824",
    d: "M95.407,345.449a1.714,1.714,0,0,0-1.8,1.757,1.784,1.784,0,0,0,1.766,1.821,1.765,1.765,0,0,0,1.736-1.846,1.707,1.707,0,0,0-1.708-1.733Z",
    transform: "translate(-78.045 -329.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_825",
    "data-name": "Caminho 825",
    d: "M260.471,318.533a1.765,1.765,0,1,0,1.669,1.806,1.8,1.8,0,0,0-1.669-1.806Z",
    transform: "translate(-199.892 -310.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_826",
    "data-name": "Caminho 826",
    d: "M303.81,345.45a1.737,1.737,0,0,0-1.751,1.73,1.77,1.77,0,1,0,3.539.076A1.744,1.744,0,0,0,303.81,345.45Z",
    transform: "translate(-233.294 -329.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_827",
    "data-name": "Caminho 827",
    d: "M274.078,345.439a1.7,1.7,0,0,0-1.779,1.775,1.778,1.778,0,0,0,1.785,1.806,1.8,1.8,0,0,0,1.73-1.867A1.717,1.717,0,0,0,274.078,345.439Z",
    transform: "translate(-210.015 -329.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_828",
    "data-name": "Caminho 828",
    d: "M244.366,345.438a1.694,1.694,0,0,0-1.806,1.742,1.747,1.747,0,1,0,3.49.009A1.689,1.689,0,0,0,244.366,345.438Z",
    transform: "translate(-188.048 -329.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_829",
    "data-name": "Caminho 829",
    d: "M321.08,318.533a1.8,1.8,0,0,0-1.751,1.73,1.77,1.77,0,1,0,3.539.067,1.781,1.781,0,0,0-1.788-1.8Z",
    transform: "translate(-245.296 -310.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_830",
    "data-name": "Caminho 830",
    d: "M230.122,318.522a1.776,1.776,0,1,0,1.791,1.687,1.773,1.773,0,0,0-1.791-1.687Z",
    transform: "translate(-177.583 -310.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_831",
    "data-name": "Caminho 831",
    d: "M284.976,293.395a1.744,1.744,0,1,0-3.487.073,1.744,1.744,0,1,0,3.487-.073Z",
    transform: "translate(-216.798 -291.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_832",
    "data-name": "Caminho 832",
    d: "M125.2,345.44a1.665,1.665,0,0,0-1.73,1.711,1.738,1.738,0,1,0,3.472.113,1.7,1.7,0,0,0-1.742-1.824Z",
    transform: "translate(-100.095 -329.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_833",
    "data-name": "Caminho 833",
    d: "M65.539,345.45a1.753,1.753,0,0,0-1.8,1.684,1.775,1.775,0,0,0,1.7,1.791,1.726,1.726,0,0,0,1.84-1.748,1.693,1.693,0,0,0-1.739-1.724Z",
    transform: "translate(-54.691 -329.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_834",
    "data-name": "Caminho 834",
    d: "M228.727,293.479a1.784,1.784,0,0,0-1.745-1.739,1.766,1.766,0,0,0-.058,3.53,1.783,1.783,0,0,0,1.8-1.794Z",
    transform: "translate(-175.263 -291.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_835",
    "data-name": "Caminho 835",
    d: "M199.952,318.528a1.76,1.76,0,0,0-1.812,1.766,1.731,1.731,0,0,0,1.7,1.76,1.764,1.764,0,0,0,.113-3.527Z",
    transform: "translate(-155.245 -310.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_836",
    "data-name": "Caminho 836",
    d: "M78.553,318.53a1.794,1.794,0,0,0-1.775,1.7,1.768,1.768,0,1,0,3.533.012,1.773,1.773,0,0,0-1.757-1.714Z",
    transform: "translate(-63.752 -310.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    "data-name": "Caminho 837",
    d: "M59.719,293.5a1.764,1.764,0,0,0-1.727-1.748,1.765,1.765,0,1,0,.037,3.53A1.756,1.756,0,0,0,59.719,293.5Z",
    transform: "translate(-49.472 -291.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    "data-name": "Caminho 838",
    d: "M290.815,318.53a1.765,1.765,0,0,0,.037,3.53,1.728,1.728,0,0,0,1.73-1.836,1.755,1.755,0,0,0-1.769-1.693Z",
    transform: "translate(-224.271 -310.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M256.834,293.523a1.764,1.764,0,1,0-1.736,1.76A1.814,1.814,0,0,0,256.834,293.523Z",
    transform: "translate(-195.989 -291.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    "data-name": "Caminho 840",
    d: "M142.527,291.74a1.766,1.766,0,0,0-.073,3.529,1.765,1.765,0,0,0,.073-3.529Z",
    transform: "translate(-112.879 -291.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_841",
    "data-name": "Caminho 841",
    d: "M114.264,291.743a1.831,1.831,0,0,0-1.754,1.748,1.765,1.765,0,1,0,1.754-1.751Z",
    transform: "translate(-92.004 -291.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_842",
    "data-name": "Caminho 842",
    d: "M313.125,293.543a1.768,1.768,0,1,0-1.757,1.742,1.813,1.813,0,0,0,1.757-1.742Z",
    transform: "translate(-238.527 -291.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    "data-name": "Caminho 843",
    d: "M169.643,318.536a1.758,1.758,0,0,0-1.833,1.766,1.815,1.815,0,0,0,1.724,1.785,1.761,1.761,0,0,0,1.76-1.727,1.742,1.742,0,0,0-1.65-1.821Z",
    transform: "translate(-132.843 -310.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    "data-name": "Caminho 844",
    d: "M139.256,318.53a1.748,1.748,0,0,0-1.727,1.73,1.775,1.775,0,0,0,1.766,1.818,1.834,1.834,0,0,0,1.742-1.748,1.773,1.773,0,0,0-1.778-1.8Z",
    transform: "translate(-110.481 -310.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_845",
    "data-name": "Caminho 845",
    d: "M170.726,291.74a1.764,1.764,0,0,0-.043,3.526,1.764,1.764,0,1,0,.043-3.526Z",
    transform: "translate(-133.722 -291.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_846",
    "data-name": "Caminho 846",
    d: "M214.419,345.44a1.727,1.727,0,0,0-1.739,1.724,1.748,1.748,0,0,0,1.724,1.745,1.721,1.721,0,0,0,1.782-1.788,1.688,1.688,0,0,0-1.766-1.678Z",
    transform: "translate(-165.982 -329.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_847",
    "data-name": "Caminho 847",
    d: "M154.978,345.449a1.7,1.7,0,0,0-1.769,1.669,1.719,1.719,0,0,0,1.663,1.785,1.757,1.757,0,0,0,1.843-1.733A1.738,1.738,0,0,0,154.978,345.449Z",
    transform: "translate(-122.06 -329.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_848",
    "data-name": "Caminho 848",
    d: "M108.9,318.529a1.756,1.756,0,1,0,0,3.511,1.713,1.713,0,0,0,1.727-1.748,1.753,1.753,0,0,0-1.721-1.763Z",
    transform: "translate(-88.02 -310.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_849",
    "data-name": "Caminho 849",
    d: "M35.807,345.45a1.717,1.717,0,0,0-1.727,1.724,1.76,1.76,0,1,0,1.727-1.724Z",
    transform: "translate(-34.08 -329.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_850",
    "data-name": "Caminho 850",
    d: "M198.866,295.28a1.762,1.762,0,0,0-.1-3.52,1.761,1.761,0,1,0,.1,3.52Z",
    transform: "translate(-154.423 -291.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_851",
    "data-name": "Caminho 851",
    d: "M87.985,293.88a1.716,1.716,0,0,0-1.623-1.818,1.689,1.689,0,0,0-1.843,1.7,1.734,1.734,0,0,0,3.465.116Z",
    transform: "translate(-69.132 -291.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_852",
    "data-name": "Caminho 852",
    d: "M48.3,318.538a1.768,1.768,0,0,0-1.812,1.785,1.749,1.749,0,0,0,1.751,1.721,1.693,1.693,0,0,0,1.736-1.717A1.727,1.727,0,0,0,48.3,318.538Z",
    transform: "translate(-42.704 -310.335)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Componente_4_14",
    "data-name": "Componente 4 \\u2013 14",
    transform: "translate(-0.007 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M265.95,11.006l3.276,3.182a1.033,1.033,0,0,1,.009,1.473L242.189,42.62a1.031,1.031,0,0,1-1.458,0l-12-11.961a1.033,1.033,0,0,1-.009-1.455l3.136-3.2a1.029,1.029,0,0,1,1.461-.012l7.459,7.343a1.03,1.03,0,0,0,1.455-.006L264.5,11.018a1.031,1.031,0,0,1,1.449-.012Z",
    transform: "translate(-171.723 -7.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M101.661,96.167c-3.1-7.067-6.266-14.11-9.419-21.155a5.352,5.352,0,0,0-5.118-3.329c-1.383-.035-2.769,0-4.152-.011a7.309,7.309,0,0,1-.807-.1c.16-.211.23-.322.317-.42C94.44,57.544,96.808,39.609,88.843,23.329c-.877-1.424-3.754-1.053-1.613,4.084A38.23,38.23,0,0,1,90.25,41.03c-2.081,0-4.079-.005-6.06,0h-8.1q-.162-2.245-.544-4.531c-.436-1.613-3.3-2.076-2.707,3.456.038.36.068.717.1,1.075H66.9c-.2-.008-.409,0-.614,0H52.723V27.194c1.356-.127,2.663-.233,3.965-.376,1.229-.135,1.9-.812,1.808-1.751-.1-1-.934-1.5-2.19-1.359-1.188.133-2.382.219-3.594.328V4.526c1.437,1.077,2.712,2.049,4.006,3a1.571,1.571,0,0,0,2.257-.192,1.536,1.536,0,0,0-.292-2.241c-.457-.411-.947-.785-1.421-1.175l.095-.192c1.773.42,3.543.836,5.235,1.234a2.2,2.2,0,0,0,.287.068c.482.171,1.2.482,1.665.671a38.227,38.227,0,0,1,11.9,7.273c4.165,3.689,5.448,1.088,4.385-.2A44.453,44.453,0,0,0,64.865,2.4a.236.236,0,0,0-.016.027A40.563,40.563,0,0,0,36.8,2.58C21.667,8.248,12.3,19.153,9.338,35.057,6.846,48.433,10.388,60.383,19.25,70.73c.222.26.433.528.774.947-1.805,0-3.356-.019-4.907.005A5.368,5.368,0,0,0,9.9,75.015Q5.173,85.587.493,96.175A5.313,5.313,0,0,0,2.534,103a15.143,15.143,0,0,0,1.924.85h93.23a4.2,4.2,0,0,1,.457-.192,5.367,5.367,0,0,0,3.516-7.484ZM89.108,44.135c.355,0,.706.032,1.161.057a38.944,38.944,0,0,1-10.2,24.923l-8.328-6c.124-.3.287-.693.463-1.085A48.555,48.555,0,0,0,74.714,55l.016.008a39.636,39.636,0,0,0,1.475-10.875h9.66c1.083,0,2.163,0,3.245,0Zm-18.762,21.8c2.474,1.811,4.913,3.6,7.354,5.381l-.176.281H66.646c1.232-1.884,2.4-3.67,3.7-5.662ZM62.772,71.3a1.354,1.354,0,0,1-.961.355c-1.919.038-3.841.027-5.762.032H52.742V61.208a37.754,37.754,0,0,1,14.765,3.565c-1.613,2.238-3.148,4.4-4.731,6.526ZM52.723,44.132h6.872l4.355,0c.544,0,1.088,0,1.632,0h7.473a38.019,38.019,0,0,1-.414,5.516c-.019.092-.038.184-.051.276a43.023,43.023,0,0,1-3.413,11.184c-.106.23-.252.441-.4.7A42.983,42.983,0,0,0,52.725,58V44.132ZM34.575,64.724A39.412,39.412,0,0,1,49.4,61.187V71.672c-3.175,0-6.274.005-9.373-.011a.858.858,0,0,1-.62-.235C37.807,69.236,36.231,67.028,34.575,64.724Zm.869,6.878H24.6l-.171-.309,7.354-5.324c1.294,1.992,2.441,3.759,3.654,5.63Zm-2.138-9.768A45.566,45.566,0,0,1,29,44.205H49.4V58.015a42.38,42.38,0,0,0-16.1,3.819Zm-4.322-20.89a44.387,44.387,0,0,1,4.2-17.414c2.709.855,5.294,1.838,7.963,2.466,2.707.636,5.492.923,8.25,1.364V40.944ZM34.729,20.52A47.524,47.524,0,0,1,49.415,4.543V24.025a38.889,38.889,0,0,1-14.686-3.5ZM44.9,3.817A53.021,53.021,0,0,0,31.819,19.245c-2.55-1.859-4.98-3.635-7.522-5.489A38.1,38.1,0,0,1,44.9,3.82Zm-22.833,12.2c2.8,2.043,5.519,4.025,8.315,6.066a47.871,47.871,0,0,0-4.55,18.865H11.772A39.355,39.355,0,0,1,22.062,16.016ZM11.8,44.216h14a48.876,48.876,0,0,0,4.582,18.841c-2.82,2.062-5.554,4.063-8.345,6.106A39.216,39.216,0,0,1,11.8,44.216ZM97.923,100.33a4.07,4.07,0,0,1-1.757.309q-22.541.024-45.084.014c-15.027,0-29.922-.049-44.881.043-2.7.016-3.619-1.694-2.552-4.006,3.023-6.55,5.927-13.154,8.8-19.772A3.1,3.1,0,0,1,15.7,74.8c13.373.043,26.747.024,40.12.024,10.266,0,20.532.019,30.8-.019A2.833,2.833,0,0,1,89.638,76.8c.558,1.445,1.248,2.839,1.878,4.255q3.573,8.043,7.14,16.085c.614,1.386.36,2.647-.733,3.186Z",
    transform: "translate(0.007 -0.001)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobal);
export default __webpack_public_path__ + "static/media/icon-global.5a06a78e274d2e5f112ccd7613bee5eb.svg";
export { ForwardRef as ReactComponent };